exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-general-ledger_date-picker{padding-left:144px;margin-top:20px}.c-general-ledger_date-picker .m-form-group{margin-right:20px}", ""]);

// exports
